import { InfinityIcon } from './infinity-icon';

export const OfferQuantity = ({ quantity }: { quantity: number }) => {
  return (
    <>
      {quantity >= 1_000 ? <InfinityIcon className="size-[15px]" /> : quantity}{' '}
      left
    </>
  );
};
